<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <!-- <template #TEST="{field,row}">
        <Button>{{row[field.key]}}</Button>
      </template> -->
  </cTable>
</template>

<script>
import { getCity, add, del, update, getDetails } from "@/api/system/city";
import { getCountry } from "@/api/system/country";

import cTable from "@/base/common/index";
export default {
  name: "city",

  components: {
    cTable
  },
  data() {
    return {
      methods: {
        list: getCity,
        getDetails,
        del,
        add,
        update,
        getCountry
      },
      config: {
        height: 600
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page.handleRequestMethods(this.type, data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 130
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              title: [
                {
                  required: true,
                  message: "city_name cannot be empty",
                  trigger: "blur"
                },
                {
                  max: 55,
                  message: "Please enter maximum length 55",
                  trigger: "blur"
                }
              ],
              code: [
                {
                  required: true,
                  message: "city_code cannot be empty",
                  trigger: "blur"
                },
                {
                  max: 255,
                  message: "Please enter maximum length 255",
                  trigger: "blur"
                }
              ],
              zipcode: [
                {
                  required: true,
                  message: "zip_code cannot be empty",
                  trigger: "blur"
                }
              ],
              country_id: [
                {
                  required: true,
                  type: "number",
                  message: "Please select the country",
                  trigger: "change"
                }
              ],
              status: [
                {
                  required: true,
                  message: "Please select the status",
                  trigger: "change"
                }
              ],
              remote_regions: [
                {
                  required: true,
                  type: "number",
                  message: "Please select the remote_regions",
                  trigger: "change"
                }
              ]
            }
          },
          grid: [
            { title: 24 },
            { province: 24 },
            { area: 24 },
            { code: 24 },
            { zipcode: 24 },
            { country_id: 24 },
            { status: 24 },
            { remote_regions: 24 }
          ],
          fields: [
            {
              name: () => this.$t("city_name"),
              key: "title",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("city_name");
              }
            },
            {
              name: () => this.$t("province"),
              key: "province",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("province");
              }
            },
            {
              name: () => this.$t("area"),
              key: "area",
              align: "center",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("area");
              }
            },
            {
              name: () => this.$t("city_code"),
              key: "code",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("city_code");
              }
            },
            {
              name: () => this.$t("zip_code"),
              key: "zipcode",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("zip_code");
              }
            },
            {
              name: () => this.$t("countryName"),
              key: "country_id",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("countryName");
              },
              options: [],
              config: { label: "title", value: "id" },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getCountry")
                  ).payload.rows;
                  this.$forceUpdate();
                }
              }
            },
            {
              name: () => this.$t("exlType"),
              key: "status",
              component: "Radio",
              options: [
                { label: this.$t("enable"), value: "ENABLE" },
                { label: this.$t("disable"), value: "DISABLE" }
              ],
              bind: {
                border: true
              }
            },
            {
              name: () => this.$t("remote_regions"),
              key: "remote_regions",
              component: "Radio",
              options: [
                { label: this.$t("YES"), value: 1 },
                { label: this.$t("NO"), value: 0 }
              ],
              bind: {
                border: true
              }
            }
          ]
        }
      },
      header: {
        searchs: [
          {
            key: "country_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("countryName");
            },
            clearable: true,
            options: [],
            config: { label: "title", value: "id" },
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "remote_regions",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("remote_regions");
            },
            clearable: true,
            options: [
              { label: this.$t("YES"), value: 1 },
              { label: this.$t("NO"), value: 0 }
            ],
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "status",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("exlType");
            },
            clearable: true,
            options: [
              { label: this.$t("enable"), value: "ENABLE" },
              { label: this.$t("disable"), value: "DISABLE" }
            ],
            bind: {
              style: "width:150px"
            }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input"
            // bind: {
            //   type: "textarea",
            //   autosize: { minRows: 2, maxRows: 2 }
            // }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            },
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open(null, () => {
                this.getModal("add").setTitle(this.$t("add"));
                this.getModal("add").type = "add";
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60
        },

        {
          name: () => this.$t("city_name"),
          key: "title",
          align: "center",
          minWidth: 100,
          tooltip: true
        },
        {
          name: () => this.$t("province"),
          key: "province",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("area"),
          key: "area",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("city_code"),
          key: "code",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("zip_code"),
          key: "zipcode",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("countryCode"),
          align: "center",
          key: "country",
          minWidth: 100,
          methods: {
            render({ row }) {
              return row.country ? row.country.title : "-";
            }
          }
        },
        {
          name: () => this.$t("remote_regions"),
          align: "center",
          minWidth: 80,
          methods: {
            render({ row }) {
              return row.remote_regions == 0 ? this.$t("NO") : this.$t("YES");
            }
          }
        },
        {
          name: () => this.$t("exlType"),
          key: "status",
          align: "center",
          minWidth: 110,
          methods: {
            render({ value }) {
              return this.$t(value);
            }
          }
        },
        {
          name: () => this.$t("createTime"),
          align: "center",
          key: "create_time",
          minWidth: 160,
          methods: {
            render({ value }) {
              return ~~value ? this.format.timeFormat(value * 1000) : "-";
            }
          }
        },
        {
          name: () => this.$t("upTime"),
          align: "center",
          key: "update_time",
          minWidth: 160,
          methods: {
            render({ value }) {
              return ~~value ? this.format.timeFormat(value * 1000) : "-";
            }
          }
        },
        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          // width({ field }) {
          //   return field.list.length * 40 + 40;
          // },
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              }
            }
            // {
            //   name: this.$t("delete"),
            //   type: "delete",
            //   fnName: "delete",
            //   bind: {
            //     type: "error"
            //   }
            // }
          ],

          methods: {
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id).then(res => {
                this.getModal("add").setTitle(this.$t("update"));
                this.getModal("add").type = "update";
                this.getModal("add").open(res.payload);
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  },
  mounted() {
    this.header.searchs.forEach(async item => {
      if (item.key === "country_id")
        item.options = (await getCountry()).data.payload.rows;
    });
  }
};
</script>
